import NavMega from 'view/nav/navMega';
import NavDropdown from 'view/nav/navDropdown';
import NavSidebar from 'view/nav/navSidebar';
import { forEach } from 'lodash';

export default class DesktopNav {
  constructor(root, hasSticky) {
    this.root = root;
    this.hasSticky = hasSticky;
    this.megas = [];
    this.dropdowns = [];

    this.init();
  }

  init() {
    const navs = document.querySelectorAll(
      '.u-nav-portal, [class*="u-nav-portal--"], .u-nav-site, [class*="u-nav-site--"]'
    );

    forEach(navs, (nav) => {
      const mega = new NavMega(nav, this.hasSticky);
      const dropdown = new NavDropdown(nav);

      if (!mega.empty) {
        this.megas.push(mega);
      }

      if (!dropdown.empty) {
        this.dropdowns.push(dropdown);
      }
    });

    if (this.root.querySelector('.u-nav-sidebar')) {
      this.sidebar = new NavSidebar(this.root.querySelector('.u-nav-sidebar'));
    }
  }

  destroy() {
    this.megas.forEach((mega) => {
      mega.destroy();
    });
    this.dropdowns.forEach((dropdown) => {
      dropdown.destroy();
    });
    this.sidebar && this.sidebar.destroy();
  }
}
